import { AfterViewInit, Component, Inject, OnInit, viewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogClose } from '@angular/material/dialog';
import { combineLatest } from 'rxjs';
import { filter } from 'rxjs/operators';
import { GoogleAnalyticsService, ISelectedContract, LoggedInUserSettings } from 'src/app/core/core';
import { UserClaims } from 'src/app/model/okta/userClaims';
import { ADPResourceService, ADPComponentsModule } from 'digital-core';
import { ModalWindowComponent } from '../modal-window/modal-window.component';
import { AriaLabelDirective } from 'src/app/shared/directives';
import { MatIcon } from '@angular/material/icon';
import { NgClass } from '@angular/common';
import { ADPImageComponent } from '../adp-image/adp-image.component';
import { MatButton } from '@angular/material/button';
declare var bootstrap: any;

@Component({
    selector: 'app-get-started-modal',
    templateUrl: './get-started-modal.component.html',
    styleUrls: ['./get-started-modal.component.scss'],
    imports: [
    ModalWindowComponent,
    AriaLabelDirective,
    MatDialogClose,
    ADPComponentsModule,
    MatIcon,
    NgClass,
    ADPImageComponent,
    MatButton
]
})
export class GetStartedModalComponent implements OnInit, AfterViewInit {
  readonly tutorialCarousel = viewChild<any>('tutorialCarousel');
  tutorialPanels: string[];

  constructor(
    public dialogRef: MatDialogRef<GetStartedModalComponent>,
    @Inject(MAT_DIALOG_DATA) public modalData: any,
    private loggedInUserSettings: LoggedInUserSettings,
    private googleAnalyticsService: GoogleAnalyticsService,
    private resourceService: ADPResourceService
  ) {}

  ngOnInit(): void {
    const joined$ = combineLatest([this.loggedInUserSettings.$selectedContract, this.loggedInUserSettings.$userClaims]).pipe(
      filter(([a, b]) => a !== null && b !== null)
    );

    joined$.subscribe(([selectedContract, userClaims]: [ISelectedContract, UserClaims]) => {
      const isUserPrimary = this.googleAnalyticsService.isUserPrimary(selectedContract, userClaims);
      const isSPOEEnabled: boolean = this.resourceService.isPortalSettingTrue("Global_SPOE_Enabled");

      if (selectedContract.isPTPO) {
        if (isUserPrimary) {
          this.tutorialPanels = this.getSetting('Tutorial_Panels_PTP_Primary')?.split(';');
        } else {
          this.tutorialPanels = this.getSetting('Tutorial_Panels_PTP_Secondary')?.split(';');
        }
      }
      else if(isSPOEEnabled) {
        if (isUserPrimary) {
          this.tutorialPanels = this.getSetting('Tutorial_Panels_SPOE_Primary')?.split(';');
        } else {
          this.tutorialPanels = this.getSetting('Tutorial_Panels_SPOE_Secondary')?.split(';');
        }
      }
      else {
        if (isUserPrimary) {
          this.tutorialPanels = this.getSetting('Tutorial_Panels_Primary')?.split(';');
        } else {
          this.tutorialPanels = this.getSetting('Tutorial_Panels_Secondary')?.split(';');
        }
      }
    });
  }

  ngAfterViewInit(): void {
    const carousel = new bootstrap.Carousel(this.tutorialCarousel().nativeElement, {
      wrap: true,
      touch: true,
    });
  }

  getSetting(name: string): string {
    return this.resourceService.getPortalSetting(name)?.Value;
  }

  closeModal() {
    this.dialogRef.close();
  }
}
